// GraphQL does not support integers larger than 32 bits.
// This const can be used in form validation to ensure
// numeric inputs do not exceed this length.
//
// https://github.com/graphql/graphql-spec/issues/73

export const MAX_32_BIT_INT = 2147483647;

export const MAX_53_BIT_INT = Number.MAX_SAFE_INTEGER;
